import { useEffect, useRef } from "react"
import "./deleteCompanyModal.css"
import "./deleteCompanyModalDark.css"
import { useSelector } from "react-redux";

export default function DeleteCompanyModal({ show, setShow,handleDeleteCompany }) {

    const modalRef = useRef();
    const getDarkModoe = useSelector(darkModes => darkModes);
    useEffect(() => {
        if (show == true) {
            modalRef.current.style.display = "flex";
        } else {
            modalRef.current.style.display = "none";
        }
    }, [show])

    const handleClose = () => {
        setShow(!show);
    }

    return (
        <div id="myModal"   className={getDarkModoe.ToggleDarkModeReducer.chekced?"modalDeletCompanyDark":"modalDeletCompanyLight"} ref={modalRef} onClick={handleClose}>


            <div className="modalDeletCompany-content">
                <div className="modalDeletCompany-header">
                    <div>
                        <p>Удалить компанию</p>
                        <div className="closeContIcon" onClick={handleClose}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" >
                                <path d="M10.6712 12L7.27521 8.60406C6.90826 8.23711 6.90826 7.64216 7.27521 7.27521C7.64216 6.90826 8.23711 6.90826 8.60406 7.27521L12 10.6712L15.3959 7.27521C15.7629 6.90826 16.3578 6.90826 16.7248 7.27521C17.0917 7.64216 17.0917 8.23711 16.7248 8.60406L13.3288 12L16.7248 15.3959C17.0917 15.7629 17.0917 16.3578 16.7248 16.7248C16.3578 17.0917 15.7629 17.0917 15.3959 16.7248L12 13.3288L8.60406 16.7248C8.23711 17.0917 7.64216 17.0917 7.27521 16.7248C6.90826 16.3578 6.90826 15.7629 7.27521 15.3959L10.6712 12Z" fill="#64748B" />
                            </svg>
                        </div>
                    </div>
                    <p className="messeageBody">Вы уверены, что хотите удалить компанию?</p>
                </div>
                <div className="modalDeletCompany-body">
                    <button className="closeCompanyModal" onClick={handleClose}>Отменить</button>
                    <button className="deleteCompanyModal" onClick={handleDeleteCompany}>Удалить</button>
                </div>

            </div>

        </div>
    )
}